import React from 'react';
import { Shield, ArrowRight, Heart, Ambulance, Scale, Briefcase, UserCheck } from 'lucide-react';
import { motion } from 'framer-motion';

const guarantees = [
  {
    icon: Heart,
    title: 'Frais medicaux et hospitalisation',
    description: "Prise en charge a 100% des frais reels, sans franchise ni delai de carence, illimite dans le pays de PVT.",
    color: 'text-rose-500 dark:text-rose-400',
    bg: 'bg-rose-50 dark:bg-rose-900/20',
  },
  {
    icon: Shield,
    title: 'Hospitalisation sans avance de frais',
    description: "Prise en charge directe en cas d'hospitalisation : vous n'avancez pas les frais !",
    color: 'text-emerald-500 dark:text-emerald-400',
    bg: 'bg-emerald-50 dark:bg-emerald-900/20',
  },
  {
    icon: Ambulance,
    title: 'Assistance complete',
    description: "Rapatriement, retour anticipe en cas de deces d'un proche, presence d'un membre de votre famille si hospitalisation de plus de 7 jours.",
    color: 'text-sky-500 dark:text-sky-400',
    bg: 'bg-sky-50 dark:bg-sky-900/20',
  },
  {
    icon: Scale,
    title: 'Responsabilite civile',
    description: 'Protection en responsabilite civile vie privee incluse dans votre contrat.',
    color: 'text-amber-500 dark:text-amber-400',
    bg: 'bg-amber-50 dark:bg-amber-900/20',
  },
  {
    icon: Briefcase,
    title: 'Assurance bagages',
    description: 'Vos bagages sont assures pendant les trajets aller-retour.',
    color: 'text-teal-500 dark:text-teal-400',
    bg: 'bg-teal-50 dark:bg-teal-900/20',
  },
  {
    icon: UserCheck,
    title: 'Support reactif depuis 2005',
    description: 'Un support reactif et convivial sur nos forums depuis 2005 !',
    color: 'text-blue-500 dark:text-blue-400',
    bg: 'bg-blue-50 dark:bg-blue-900/20',
  },
];

export function GuaranteesSection() {
  return (
    <section className="py-12 sm:py-20 bg-gray-50 dark:bg-gray-800/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-10 sm:mb-14"
        >
          <h2 className="text-xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-3">
            Les principales garanties
          </h2>
          <p className="text-sm sm:text-base text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            Globe PVT vous offre une protection optimale pendant toute la duree de votre sejour
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {guarantees.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.08 }}
              className="bg-white dark:bg-gray-800 rounded-2xl p-5 sm:p-6 border border-gray-100 dark:border-gray-700/50 hover:shadow-lg hover:border-gray-200 dark:hover:border-gray-600 transition-all duration-300 group"
            >
              <div className={`w-11 h-11 rounded-xl ${item.bg} flex items-center justify-center mb-4 transition-transform group-hover:scale-110`}>
                <item.icon className={`w-5 h-5 ${item.color}`} />
              </div>
              <h3 className="text-base sm:text-lg font-bold text-gray-900 dark:text-white mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4"
        >
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Pour plus de details, consultez les notices d'information :
          </p>
          <div className="flex items-center gap-3">
            <a
              href="https://www.acs-ami.com/files/pdf/Globe-PVT-EIC-Canada-IB-fr.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-4 py-2 bg-white dark:bg-gray-800 text-sm font-medium text-emerald-600 dark:text-emerald-400 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-emerald-300 dark:hover:border-emerald-600 transition-colors"
            >
              PVT Canada
              <ArrowRight className="w-3.5 h-3.5" />
            </a>
            <a
              href="https://www.acs-ami.com/files/pdf/Globe-PVT-WHV-IB-fr.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-4 py-2 bg-white dark:bg-gray-800 text-sm font-medium text-emerald-600 dark:text-emerald-400 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-emerald-300 dark:hover:border-emerald-600 transition-colors"
            >
              Autres destinations
              <ArrowRight className="w-3.5 h-3.5" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
